export const GET_FORMATTED_ZONES_SENDING = 'GET_FORMATTED_ZONES_SENDING'

export const GET_FORMATTED_ZONES_SUCCESS = 'GET_FORMATTED_ZONES_SUCCESS'

export const GET_FORMATTED_ZONES_FAILED = 'GET_FORMATTED_ZONES_FAILED'

export const SET_CHECKED_SECTORS = 'SET_CHECKED_SECTORS'